import React, { useEffect, useState } from 'react';
import { getResults, getCurrentRace, getRacePicks, getDrivers, isRaceLocked } from '../../api';
import RaceSelector from '../../components/RaceSelector';
import RaceSubmissions from '../../components/RaceSubmissions';

export default function Results() {
    const [results, setResults] = useState([]);
    const [picks, setPicks] = useState([]);
    const [selectedRace, setSelectedRace] = useState('');
    const [driversMap, setDriversMap] = useState({});
    const [maskPicks, setMaskPicks] = useState(false);
    const displayedResults = (results || []).slice(3, 10);

    useEffect(() => {
        if (!selectedRace) return;
        // results are arrays of driver IDs; load drivers map for display
        Promise.all([getResults(selectedRace), getRacePicks(selectedRace), getDrivers()]).then(([res, pk, drv]) => {
            const map = {};
            (drv || []).forEach((d) => { map[d.id] = (d.name || `${d.first_name || ''} ${d.last_name || ''}`).trim(); });
            setDriversMap(map);
            setResults(res || []);
            setPicks(pk || []);
        });
    }, [selectedRace]);

    useEffect(() => {
        // default to current race from season-state when available
        getCurrentRace().then((id) => {
            if (id && !selectedRace) setSelectedRace(id);
        });
    }, []);

    useEffect(() => {
        if (!selectedRace) return;
        // Mask picks when the selected race is the current race and picks are not locked
        Promise.all([getCurrentRace(), isRaceLocked(selectedRace)])
            .then(([cur, locked]) => {
                setMaskPicks(cur && String(cur) === String(selectedRace) && !locked);
            })
            .catch(() => setMaskPicks(false));
    }, [selectedRace]);

    return (
        <div className="results-page">
            <h3>Race Results</h3>

            <div className="mb-3">
                <label className="form-label">Select Race</label>
                <RaceSelector value={selectedRace} onChange={(id) => setSelectedRace(id)} includePlaceholder={false} />
            </div>

            {results && results.length ? (
                <div>
                    <h5>Official Order (Positions 4-10)</h5>
                    <ol>
                        {displayedResults.map((r, i) => <li key={i} value={i + 4}>{driversMap[r] || r}</li>)}
                    </ol>
                </div>
            ) : (
                <div className="alert alert-secondary">No official results published yet for this race.</div>
            )}

            <RaceSubmissions raceId={selectedRace} results={results} />
        </div>
    );
}
